module.exports = __webpack_public_path__ + "static/img/loadingGif.0e6e0f46.gif";